import React, {Component} from 'react';
import { NavLink } from "react-router-dom";
import PersonMessages from './messages.component'
import BurgerMenu from './burger_menu.component'

class UpperMenu extends Component {

  onPaths = (paths) => {
    return (match, location) => {
      return paths.includes(location.pathname);
    };
  }

  
  onLoggedOutRefresh = () => {
    this.props.onLoggedOutRefresh();
  }

  render() { 
    return (
      <React.Fragment>
        <div className="cntered-flex ">
            <div className="hp_uppermenu">
                <div className="hp_uppermenu_MOD">
                    <img src={"/images/site/mod.png"} alt=""/>
                </div>
                <div className="hp_uppermenu_hr">
                    <img src={"/images/site/hr.png"} alt=""/>
                </div>
                <div className="hp_uppermenu_title">הזמנת חופשה שנתית</div>
                <div className="hp_uppermenu_LineVer marginRight24"></div>


                <BurgerMenu  onLoggedOutRefresh={this.onLoggedOutRefresh} />


                <div className="hp_uppermenu_wideScreen">

                <NavLink className="hp_uppermenu_item_nonActive marginRight50" activeClassName="hp_uppermenu_item_Active marginRight50"
                    to="/" 
                    isActive={ this.onPaths(["/", "/results"])}  >
                    {<div className="" >ראשי</div>}
                </NavLink>

                <NavLink   className="hp_uppermenu_item_nonActive marginRight50" activeClassName="hp_uppermenu_item_Active marginRight50"   
                    to={"/orders"}>
                    {<div className="" >הזמנות שלי</div>}
                </NavLink >
                  
                <NavLink   className="hp_uppermenu_item_nonActive marginRight50" activeClassName="hp_uppermenu_item_Active marginRight50"   
                    to={"/hotels"}>
                    {<div className="" >רשימת כל בתי המלון</div>}
                </NavLink >

                <NavLink   className="hp_uppermenu_item_nonActive marginRight50" activeClassName="hp_uppermenu_item_Active marginRight50"   
                    to={"/images/policy.pdf"} target="_blank" >
                    {<div className="" >מדיניות</div>}
                </NavLink >
                </div>

                <PersonMessages  
                    personData={this.props.personData}
                    onLoggedOutRefresh={this.onLoggedOutRefresh}
                />
                
            </div>						            
        </div>				
        <div className="hp_uppermenu_line"></div>	
        </React.Fragment>
    )
  }
}

export default UpperMenu;
